<template>
  <div :class="{ 'has-logo': showLogo }">
    <!-- 这里便是左侧的路由页面 -->
    <logo v-if="showLogo" :collapse="isCollapse" />

    <el-scrollbar wrap-class="scrollbar-wrapper">
      <!-- 导航栏 -->
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="(route,index) in permission_routes"
          :key="index"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Layout from '@/layout'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'
import { constantRoutes } from '@/router'
import { array } from 'jszip/lib/support'

export default {
  components: { SidebarItem, Logo },
  data() {
    return {
      // permission_routes: [],
      c: true,
      num: 0
    }
  },
  mounted() {},
  computed: {
    permission_routes: function() {
      permission_routes.sotr((x, y) => {
        return console.log(x, y)
      })
    },
    ...mapGetters(['sidebar', 'roles', 'routerlist', 'permission_routes']),
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>
